var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.861 8.96l1.294-1.294a2.992 2.992 0 000-4.226 2.993 2.993 0 00-4.226 0l-3.25 3.25a.703.703 0 01-.014.013L6.053 8.316a1.152 1.152 0 000 1.626c.449.448 1.176.448 1.625 0l3.9-3.901a.69.69 0 11.976.974l-3.9 3.902a2.521 2.521 0 01-1.789.74 2.521 2.521 0 01-1.787-.74 2.532 2.532 0 010-3.577l3.9-3.9.013-.013.963-.962a4.371 4.371 0 016.176 0 4.372 4.372 0 010 6.176l-3.25 3.251a.701.701 0 01-.017.016l-2.26 2.26a6.187 6.187 0 01-4.388 1.814 6.187 6.187 0 01-4.388-1.815A6.16 6.16 0 01.017 9.78a6.16 6.16 0 011.81-4.388L7.028.189a.69.69 0 01.975.976l-5.201 5.2A4.793 4.793 0 001.395 9.78c0 1.293.5 2.506 1.407 3.413A4.794 4.794 0 006.215 14.6c1.294 0 2.506-.5 3.414-1.407l2.261-2.262.014-.013 1.583-1.584.367-.367.007-.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default ForwardRef;